<div class="container">
    <div class="row">
        <div class="col section-title-full">
            <h1>
                <span i18n>Comunicaciones</span>
            </h1>
        </div>
    </div>
</div>

<div class="container">
    <div class="row my-5">
        <div class="col">
            <div class="row">
                <div class="col-12">
                    <p i18n>Para ponerte en contacto con nuestro personal puedes crear un nuevo ticket y te responderan lo antes posible.</p>
                </div>
                <div class="col-12">
                    <h2 class="my-4" i18n>Tickets</h2>
        
                    <div class="card">
                        <div class="col-12">
                            <table class="table table-responsive table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col" i18n>Fecha</th>
                                        <th scope="col" i18n>Mensaje</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="clickable" *ngFor="let noti of comunications" (click)="selectTicket(noti.uuid)">
                                        <td>{{noti.timestampOpened.timestamp | date:'dd/MM/yyyy HH:mm'}}</td>
                                        <td>{{noti.subject}}</td>
                                    </tr>
                                    <tr *ngIf="comunications.length == 0">
                                        <td colspan="2" class="text-center" i18n>No hay tickets</td>
                                    </tr>
                            </table>
                        </div>
                    </div>

                    <h2 class="my-4" i18n>Nuevo Ticket</h2>
                    <div class="card">
                        <div class="row">
                            <div class="col-12">
                                <label for="subject" class="form-label"><span i18n>Asunto</span>: </label>
                                <input type="text" class="form-control" id="subject" [(ngModel)]="newComunication.subject">
                            </div>
                            <div class="col-12 mb-3">
                                <label for="message" class="form-label"><span i18n>Mensaje</span>: </label>
                                <textarea class="form-control" id="message" rows="3" [(ngModel)]="newComunication.message"></textarea>
                            </div>
                            <div class="col-12 text-right btn-actions">
                                <button type="button" class="btn btn-primary" (click)="createTicket()" i18n>Crear</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>